import Container from "components/layout/container";
import ErrorBoundary from "components/layout/router-error-boundary";
import NotFound from "components/pages/not-found";
import * as Pages from "./pages";

export default function createRoutes() {
  return [{
    children: [
      {Component: Pages.SignUp, path: "/"},
      {Component: Pages.Results, path: "/results/:id"},
      {Component: Pages.SignUp, path: "/signup"},
      {Component: Pages.Survey, path: "/survey/:id"},
      {Component: NotFound, path: "*"}
    ],
    Component: Container,
    ErrorBoundary
  }];
}
